module.exports = __webpack_public_path__ + "img/diamond_gem.be5030ca.webp";